import { useState, useEffect } from "react";
import { Settings, ChevronDown, ChevronUp, Shield, CheckCircle2, AlertTriangle, Loader2 } from "lucide-react";
import NovedadReportingModal from "./NovedadReportingModal.jsx";
import "../../../css/OnRoad.css";

export default function ActionsSection({ 
    onNormalidad, 
    onPreOperacional,
    loadingNormalidad = false,
    estadoOperativo = "CARGUE"
}) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showNovedadModal, setShowNovedadModal] = useState(false);

    // Datos del localStorage para el modal
    const manifiesto = localStorage.getItem('manifiesto');
    const conductor = localStorage.getItem('nombreConductor') || localStorage.getItem('conductor');
    const placa = localStorage.getItem('placa');

    // const containerClass = compact ? "general-actions-compact" : "general-actions";

    // Auto-expandir cuando está en EN_RUTA
    useEffect(() => {
        if (estadoOperativo === "EN RUTA") {
            setIsExpanded(true);
        } else {
            setIsExpanded(false);
        }
    }, [estadoOperativo]);

    const toggleExpanded = () => {
        setIsExpanded(prev => !prev);
    };

    // Funciones de manejo centralizadas y optimizadas
    const handlePreOperacionalClick = () => {
        onPreOperacional?.();
    };

    const handleNormalidadClick = () => {
        if (!loadingNormalidad) {
            onNormalidad?.();
        }
    };

    const handleNovedadClick = () => {
        setShowNovedadModal(true);
    };
    
    // Función para manejar eventos de teclado
    const createKeyHandler = (callback) => (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            callback();
        }
    };

    // Función para prevenir propagación en botones
    const createClickHandler = (callback) => (e) => {
        e.stopPropagation();
        callback();
    };

    

    return (
        <div className="actions-section">
            {/* Header clickeable para expandir/colapsar */}
            <div 
                className={`actions-header clickeable ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
            >
                <Settings size={18} />
                <span className="actions-title">Acciones de Viaje</span>
                <span className="actions-count">
                    3 opciones
                </span>
                <div className="expand-icon">
                    {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </div>
            </div>
            
            {/* Contenido desplegable */}
            <div className={`actions-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
                <div className={`${isExpanded ? 'general-actions-compact' : 'general-actions'}`}>
                    {/* Card Pre-Operacional*/}
                    <div 
                        className="action-card action-card-clickeable pre-operacional" 
                        onClick={handlePreOperacionalClick}
                        role="button"
                        tabIndex={0}
                        onKeyDown={createKeyHandler(handlePreOperacionalClick)}
                    >
                        <div className="action-header">
                            <div className="action-icon shield">
                                <Shield size={16} />
                            </div>
                            <div className="action-info">
                                <h6 className="action-title">Pre-Operacional</h6>
                                <p className="action-subtitle">Verificación de seguridad</p>
                            </div>
                            <button 
                                className="action-btn outline-primary" 
                                onClick={createClickHandler(handlePreOperacionalClick)}
                            >
                                Abrir
                            </button>
                        </div>
                    </div>

                    {/* Card Reportar Normalidad */}
                    <div 
                        className={`action-card action-card-clickeable normalidad ${loadingNormalidad ? 'loading' : ''}`}
                        onClick={handleNormalidadClick}
                        role="button"
                        tabIndex={0}
                        onKeyDown={createKeyHandler(handleNormalidadClick)}
                    >
                        <div className="action-header">
                            <div className="action-icon check">
                                <CheckCircle2 size={16} />
                            </div>
                            <div className="action-info">
                                <h6 className="action-title">Reportar Normalidad</h6>
                                <p className="action-subtitle">Todo en orden</p>
                            </div>
                            <button 
                                className="action-btn outline-success" 
                                onClick={createClickHandler(handleNormalidadClick)}
                                disabled={loadingNormalidad}
                            >
                                {loadingNormalidad ? (
                                    <>
                                        <Loader2 size={16} className="animate-spin" />
                                        Enviando...
                                    </>
                                ) : (
                                    'Reportar'
                                )}
                            </button>
                        </div>
                    </div>
                    {/* Card Reportar Novedad */}
                    <div 
                        className="action-card action-card-clickeable novedad" 
                        onClick={handleNovedadClick}
                        role="button"
                        tabIndex={0}
                        onKeyDown={createKeyHandler(handleNovedadClick)}
                    >
                        <div className="action-header">
                            <div className="action-icon alerta">
                                <AlertTriangle size={16} />
                            </div>
                            <div className="action-info">
                                <h6 className="action-title">Reportar Novedad</h6>
                                <p className="action-subtitle">Incidente o irregularidad</p>
                            </div>
                            <button 
                                className="action-btn outline-danger" 
                                onClick={createClickHandler(handleNovedadClick)}
                            >
                                Reportar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal de Novedad */}
            <NovedadReportingModal
                isOpen={showNovedadModal}
                onClose={() => setShowNovedadModal(false)}
                manifiesto={manifiesto}
                conductor={conductor}
                placa={placa}
            />
        </div>
    );
}